import { Component, input } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { WinCardFirstVariantConfig } from '@shared/models';
import { RewardPipe, VariableReplacementPipe } from '@shared/pipes';

@Component({
  selector: 'b2c-variant1',
  styleUrl: './variant1.component.scss',
  templateUrl: './variant1.component.html',
  imports: [RewardPipe, VariableReplacementPipe],
})
export class Variant1Component extends BaseComponent {
  amount = input<number>(0);
  config = input.required<WinCardFirstVariantConfig>();
}
